<template lang="pug">
Container(@loaded="afterload" :itemId="fileId")
    iframe(v-if="url" :src="url" style="width: 100%; height: calc(100vh - 5px); border: none")
</template>

<script>
import Container from './Container.vue';
import axios from 'axios';
const host = '/api/fs';

export default {
    props: ['fileId'],
    data() {
        return {
            id: '',
            url: null,
            header: {
                headers: {
                    'x-jwt': this.$api.jwt,
                }
            }
        }
    },
    methods: {
        afterload(info) {
            this.id = info.id;
            this.load();
        },
        load() {
            axios.get(`${host}/download/${this.id}`, {
                ...this.header,
                responseType: 'blob',
            }).then(res => {
                const pdfFile = new Blob([res.data], { type: 'application/pdf' });
                this.url = window.URL.createObjectURL(pdfFile);
            })
        }
    },
    components: {
        Container
    }
}
</script>
